/**
 * Copyright © Veeam Software Group GmbH.
 */

import { FormValidator } from '@veeam-vspc/shared/components';

import type { FormErrors } from '@veeam-vspc/shared/components';
import type { VspcLang } from 'configs/languages';

import { domainUserNameNotLocalhost } from 'core/utils/validators';

import type { VbrDeploySettingsWizardModel } from '../../../entries';

export const stepValidate = (lang: VspcLang) => (data: VbrDeploySettingsWizardModel): FormErrors<VbrDeploySettingsWizardModel> => {
    const validator = new FormValidator(data);

    validator
        .validate('adminUserName')
        .string()
        .maxLength(128)
        .required()
        .check(v => domainUserNameNotLocalhost(v, lang));

    validator
        .validate('adminPassword')
        .password()
        .maxLength(256)
        .required();

    return validator.result();
};
